module.exports = __webpack_public_path__ + "static/media/render-avantte.a785e5c5.png";